import React from 'react'
import { Box, Switch, FormControlLabel, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useViewModeOverride } from '../hooks/useViewModeOverride'
import { useIsMobileOrTablet } from '../hooks/useIsMobileOrTablet'

const ToggleContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: 1300,
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(1, 1.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
  border: '1px solid rgba(255, 255, 255, 0.1)'
}))

const StyledSwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: '#3B59EC',
      '& + .MuiSwitch-track': {
        backgroundColor: '#3B59EC'
      }
    }
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'rgba(255, 255, 255, 0.3)'
  }
}))

const LabelText = styled(Typography)(() => ({
  color: 'rgba(255, 255, 255, 0.9)',
  fontSize: '0.875rem',
  fontWeight: 500,
  whiteSpace: 'nowrap'
}))

/**
 * ViewModeToggle component
 * Allows users on iPads to switch between mobile and desktop views
 * Only visible on iPads (not mobile phones)
 * Default is desktop view (toggle OFF = desktop, toggle ON = mobile)
 */
export const ViewModeToggle: React.FC = () => {
  const { forceDesktop, setForceDesktop } = useViewModeOverride()
  const isIPad = useIsMobileOrTablet()

  // Only show toggle on iPads
  if (!isIPad) {
    return null
  }

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    // When toggle is ON, forceDesktop = true means we want mobile view
    // When toggle is OFF, forceDesktop = false means we want desktop view (default)
    setForceDesktop(event.target.checked)
    // Reload the page to apply the view mode change
    window.location.reload()
  }

  return (
    <ToggleContainer>
      <LabelText>Mobile</LabelText>
      <FormControlLabel
        control={<StyledSwitch checked={forceDesktop} onChange={handleToggle} />}
        label=""
        sx={{ margin: 0 }}
      />
    </ToggleContainer>
  )
}
